<template>
  <b-container>
    <b-card>
      <validation-observer>
        <b-form>
          <b-form-group
            v-for="(_, index) in files"
            :key="index"
            :label-for="`file${index+1}`"
            :label="`Arquivo ${index+1}`"
          >
            <b-row>
              <b-col md="10">
                <validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="Data Inicial"
                    rules="pdf"
                  >
                    <b-form-file
                      :id="`file${index+1}`"
                      v-model="files[index]"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Arraste ou selecione um arquivo"
                      drop-placeholder="Arraste o arquivo aqui."
                      browse-text="Procurar"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </validation-provider>
              </b-col>

              <b-button
                v-if="index > 0"
                variant="danger"
                @click="removeFile(index)"
              >
                Remover
              </b-button>
            </b-row>
          </b-form-group>
          <b-button
            class="d-block mb-3"
            variant="primary"
            :disabled="files.some(item => !item)"
            @click="addFile"
          >
            Adicionar Arquivo
          </b-button>
          <b-button
            :disabled="!files.some(item => item)"
            variant="primary"
            @click="importFile"
          >
            Importar
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </b-container>
</template>

<script>
import {
    BContainer, BFormFile, BFormGroup, BCard, BForm, BButton, BRow, BCol,
} from 'bootstrap-vue';

import { ValidationProvider, ValidationObserver } from 'vee-validate';

import FgtsService from '@/service/fgts/fgts';

import '@validations';

export default {
    components: {
        BContainer, BFormFile, BFormGroup, BCard, BForm, BButton, BRow, BCol, ValidationProvider, ValidationObserver,
    },
    data() {
        return {
            files: [null],
        };
    },

    methods: {
        addFile() {
            this.files.push(null);
        },

        removeFile(index) {
            this.files.splice(index, 1);
        },

        async importFile() {
            const isConfirmed = await this.confirmAnAction('Você deseja realmente importar esse arquivo?');

            if (!isConfirmed) return;
            this.callLoading(true);
            const { status } = await FgtsService.import(this.files.filter(item => item));
            this.callLoading(false);
            if (status === 204) {
                this.files = [null];
                this.modalSuccess('Arquivos importado com sucesso');
            } else {
                this.modalError('Erro ao importar arquivos');
            }
        },
    },
};
</script>
